// extracted by mini-css-extract-plugin
module.exports = {"navDrawerItem":"_1KLvb"};